module.exports = __webpack_public_path__ + "img/dollarIcon.png";